var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide"},[_c('img',{attrs:{"src":_vm.headimg,"alt":""}}),_vm._v(" "),_c('div',{staticClass:"guide-title"},[_c('div',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('img',{attrs:{"src":_vm.enimg,"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-166264eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DrugGuide.vue
// module id = null
// module chunks = 